import React from "react"
import { Link } from "gatsby"

const Image = ({slug, image}) => {
  return <Link to={slug}>
    <img sizes="(min-width: 40em) 60vw, 100vw" alt="" srcSet={image.srcSet}  />
    </Link>
}

export default Image